import initSnowplow from './snowplow';

export default ({ environment, anonymousTracking = false }) => {
  if (!environment) {
    throw new Error(`Analytics - Environment is invalid, received ${environment}.`);
  }

  // eslint-disable-next-line import/no-dynamic-require, global-require
  const envVars = require(`./envs/${environment}`);
  envVars.anonymousTracking = anonymousTracking;

  initSnowplow(envVars);
};
